import React from 'react';
import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { aud, fmtDate } from './utils';

const label = (p, g) => (g === 'month' ? fmtDate(`${p}-01`, { month: 'short', year: '2-digit' }) : fmtDate(p, { day: '2-digit', month: 'short' }));

export const CollectionChart = ({ data, granularity }) => {
  const rows = data.map((d) => ({ ...d, label: label(d.period, granularity) }));
  return (
    <div className="rounded-2xl border border-[#E8E4DC] bg-white p-5" data-testid="collection-chart">
      <div className="mb-4 flex items-baseline justify-between">
        <h3 className="font-heading text-lg font-semibold text-[#3A3530]">Collected vs expected</h3>
        <span className="text-xs text-[#9B9590]">Per {granularity}</span>
      </div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={200}>
          <ComposedChart data={rows} margin={{ top: 4, right: 8, left: -8, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#EFEBE3" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#9B9590' }} tickLine={false} axisLine={false} />
            <YAxis tick={{ fontSize: 11, fill: '#9B9590' }} tickLine={false} axisLine={false} tickFormatter={(v) => `$${v}`} />
            <Tooltip formatter={(v) => aud(v)} contentStyle={{ borderRadius: 12, borderColor: '#E8E4DC', fontSize: 12 }} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="collected" name="Collected" fill="#8B9D83" radius={[6, 6, 0, 0]} maxBarSize={36} />
            <Line dataKey="expected" name="Expected" stroke="#D4A574" strokeWidth={2} dot={{ r: 3 }} type="monotone" />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
